import {
  AppBar,
  Box,
  Container,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import logoImg from '../assets/company-logo.png'
import useRwd from '../utils/useRwd'
import styled from '@emotion/styled'
import { useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import { Padding } from '@mui/icons-material'

const StyledNavTitle = styled(Typography)`
font-family: GenYOGothic2TW,
color: #707070,
font-size: 1.5rem,
font-weight: medium,
`

export default function Menu() {
  const { isPC, isToplet, isPhone } = useRwd()
  const [openMenu, setOpenMenu] = useState(false)

  const navList = [
    {
      title: '產品介紹',
      path: '/products',
    },
    {
      title: '公司簡介',
      path: '/about',
    },
  ]

  return (
    <>
      <AppBar
        position="static"
        sx={{ backgroundColor: '#ffffff', width: '100%' }}
      >
        <div style={{ width: '80%', margin: 'auto' }}>
          <Toolbar>
            <Link to="/">
              <img src={logoImg} alt="logo" style={{ height: '3.5em' }} />
            </Link>

            {/* PC、平板 */}
            {(isPC || isToplet) && (
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '3em',
                }}
              >
                {navList?.map((item, i) => (
                  <Link
                    to={item.path}
                    key={i}
                    style={{ textDecoration: 'none' }}
                  >
                    <StyledNavTitle>{item.title}</StyledNavTitle>
                  </Link>
                ))}
              </Box>
            )}

            {/* 手機 */}
            {isPhone && (
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  position: 'relative',
                }}
              >
                <IconButton
                  edge="end"
                  color="primary"
                  aria-label="menu"
                  onClick={() => setOpenMenu(true)}
                >
                  <MenuIcon />
                </IconButton>

                <Drawer
                  anchor="right"
                  open={openMenu}
                  onClose={(e) => setOpenMenu(false)}
                  style={{ position: '' }}
                >
                  <List
                    sx={{
                      width: 180,
                      textAlign: 'center',
                      margin: '0 auto',
                    }}
                    onClick={() => setOpenMenu(false)}
                  >
                    {navList?.map((item, i) => (
                      <Link
                        to={item.path}
                        key={i}
                        style={{
                          textDecoration: 'none',
                          pointerEvents: 'auto',
                          padding: '0.5em',
                        }}
                      >
                        <StyledNavTitle>{item.title}</StyledNavTitle>
                      </Link>
                    ))}
                  </List>
                </Drawer>
              </Box>
            )}
          </Toolbar>
        </div>
      </AppBar>
    </>
  )
}
